import { render, staticRenderFns } from "./TabsTab.vue?vue&type=template&id=7634775a&scoped=true&"
import script from "./TabsTab.vue?vue&type=script&lang=js&"
export * from "./TabsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7634775a",
  null
  
)

export default component.exports